import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Tackling the worst first</div>
                                            <p>
                                                Avoidance-based coping (that is, putting off tasks that you’ve
                                                been dreading) is an ineffective
                                                strategy. It makes you more likely to miss deadlines and the
                                                cumulative anxiety it causes will
                                                distract you from other responsibilities, also.
                                            </p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>MAINTAINING EFFORT
                                            </div>
                                            <p>Once you have started working, delivering every time means
                                                maintaining effort and concentration.
                                                When our concentration is interrupted (for example, to make a
                                                phone call, or check an email), it
                                                is difficult to re-engage in what we were doing beforehand.
                                                Regular interruptions have the same
                                                effect as temporarily reducing our IQ. In particular, it has
                                                been found that the average worker’s
                                                functioning IQ temporarily drops 10 points when multitasking.
                                                This highlights the importance of
                                                reducing distractions.<a className="superscripttext"
                                                                         href="further_info.php?course=300"><sup>4</sup></a>
                                            </p>
                                            <p>Decide which method of delivery you use and how you maintain
                                                momentum – or change your
                                                approach in different situations:</p>

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport  tablesrink uiheading paraspace1">
                                                <tbody>
                                                <tr>
                                                    <th width="4%" align="left" valign="top"
                                                        className="green_curve">Delivery Style
                                                    </th>
                                                    <th width="20%" align="left" valign="top"
                                                        className=" green_curve1">Definition
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="4%" align="left" valign="top"
                                                        className="lightgreen"><p>Initiator </p></td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Starts but gets bored quickly.
                                                        Has a strong push to initiate tasks and projects
                                                        but after initial effort loses momentum to complete the
                                                        work. </p>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="4%" align="left" valign="top"
                                                        className="darkgreen"><p>Completer </p></td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="darkgreen"><p>Always finishes work they
                                                        start. Maintains momentum throughout the task
                                                        until completed. May not initiate tasks.</p>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td width="4%" align="left" valign="top"
                                                        className="lightgreen"><p>Interested </p></td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Only completes the work if
                                                        interested in the content. Otherwise, will move on
                                                        to or be distracted by something more interesting.</p>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="4%" align="left" valign="top"
                                                        className="darkgreen"><p>Plodder </p></td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="darkgreen"><p>Takes a methodical approach
                                                        when undertaking the task or project and
                                                        proceeds slowly but steadily through the work. They may
                                                        seem to lack energy
                                                        to work quickly and effectively.</p>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="4%" align="left" valign="top"
                                                        className="lightgreen"><p>Delegator </p></td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Gives various elements of the
                                                        work to other people to complete. May not have
                                                        enough time for the work or would rather use others to
                                                        complete the tasks.</p>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="4%" align="left" valign="top"
                                                        className="darkgreen"><p>Gladiator </p></td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="darkgreen"><p>Someone who always points out
                                                        risks and challenges if the work is not
                                                        being completed to their standards. They may come across
                                                        as obstructive
                                                        or combative.</p>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="4%" align="left" valign="top"
                                                        className="lightgreen"><p>Daydreamer </p></td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Not focused on the practical
                                                        delivery, rather enjoys the more abstract,
                                                        strategic element of the work. Prefers to do the
                                                        thinking and leave others
                                                        to carry out the practical elements of the task.</p>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="4%" align="left" valign="top"
                                                        className="darkgreen"><p>Procrastinator </p></td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="darkgreen"><p>Will not complete the work
                                                        until the last minute. Leaves difficult things to
                                                        the end and often does the planning rather than the
                                                        activity required.</p>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="4%" align="left" valign="top"
                                                        className="lightgreen"><p>Enthusiast </p></td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Two steps ahead of everyone
                                                        else. Highly involved and keen for the work to
                                                        be completed but often works at own pace and leaves
                                                        others behind. Can get
                                                        frustrated easily. </p>

                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <p>Now, consider the different situations outlined in the table on
                                                the next page and write down how
                                                you (honestly) think you would go about achieving an objective
                                                to deadline and what you would
                                                do in each situation to maintain momentum. If this reveals that
                                                you would use different methods
                                                in the various situations, think how, in future, you could
                                                amalgamate these methods to achieve
                                                consistent, effective delivery. </p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}